// IMPORTANT Autogenerated file
/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { CofiDto, ResultDto } from '@ideapa/common-dto';
import { FilterValue, PagedResultDto } from '@ideapa/common-interfaces';

import { ApiClientConfig } from '../api-client-config';
import { of, tap } from 'rxjs';

@Injectable()
export class CofiApiClient extends BaseCRUDApiClient<CofiDto> {
  baseUrl = this.config.apiEndpoint + '/cofi';

  private _pagedCacheWithTotals: Map<
    string,
    {
      data: PagedResultDto<CofiDto> & {
        total: number;
      };
      expiration: Date;
    }
  > = new Map();

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  override clearCache() {
    this._pagedCache.clear();
    this._pagedCacheWithTotals.clear();
  }

  canImport(body: { codiceTipologia: string }) {
    return this.http.post<boolean>(`${this.baseUrl}/can-import`, body);
  }

  canDelete(body: { codiceTipologia: string }) {
    return this.http.post<boolean>(`${this.baseUrl}/can-delete`, body);
  }

  importExcelFile(file: File, codiceTipologia: string) {
    this._pagedCache.clear();
    this._pagedCacheWithTotals.clear();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('codiceTipologia', codiceTipologia);
    return this.http.post<ResultDto>(this.baseUrl + '/import-excel', fd);
  }

  deleteRecordTipologia(codiceTipologia: string) {
    this._pagedCache.clear();
    this._pagedCacheWithTotals.clear();
    return this.http.get(
      `${this.baseUrl}/delete-record-tipologia/${codiceTipologia}`
    );
  }

  getPagedByTypeWithTotals(
    take: number,
    skip: number,
    orderBy?: { [field: string]: 'asc' | 'desc' },
    filters?: FilterValue[],
    join?: string[],
    areDomainUserFiltersDisabled?: boolean,
    isEntitySelectionLimited?: boolean,
    areEnteAnnoFiltersDisabled?: boolean
  ) {
    const mappedFilters = this.buildPagedFilters(filters);

    const request = {
      skip,
      take,
      orderBy,
      filters: mappedFilters,
      join,
      areDomainUserFiltersDisabled: areDomainUserFiltersDisabled,
      isEntitySelectionLimited: isEntitySelectionLimited,
      areEnteAnnoFiltersDisabled: areEnteAnnoFiltersDisabled,
    };

    const cacheKey = JSON.stringify(request);
    const cached = this._pagedCacheWithTotals.get(cacheKey);
    if (cached) {
      if (cached.expiration > new Date()) {
        return of(cached.data);
      } else {
        this._pagedCacheWithTotals.delete(cacheKey);
      }
    }

    return this.http
      .post<PagedResultDto<CofiDto> & { total: number }>(
        `${this.baseUrl}/pagedwithtotals`,
        request
      )
      .pipe(
        tap((result) =>
          this._pagedCacheWithTotals.set(cacheKey, {
            data: result,
            expiration: new Date(
              Date.now() + 60 * 1000 * this.CACHE_EXPIRATION_MIN
            ),
          })
        )
      );
  }
}
